import axios from 'axios'


export function getUserType(data) {
    return axios({
        method: 'get',
        url:'/user/common/getParamater?paratype='+data,
        headers:{
            'Authorization': 'Bearer '+sessionStorage.getItem("access_token")
        }
    })
}


export function findPeopleFlowNew(data) {
    return axios({
        method: 'post',
        url:'/user/smartPeopleFlow/findPeopleFlowNew',
        data: data,
        headers:{
            'Authorization': 'Bearer '+sessionStorage.getItem("access_token")
        }
    })
}

export function findPeoplePassRecord(data) {
    return axios({
        method: 'get',
        url:'/user/passRecord/list',
        params: data,
        headers:{
            'Authorization': 'Bearer '+sessionStorage.getItem("access_token")
        }
    })
}

export function exportPeopleFlowNew(data) {
    return axios({
        method: 'post',
        url:'/user/smartPeopleFlow/exportPeopleFlowNew',
        data: data,
        responseType: 'blob',
        headers:{
            'Authorization': 'Bearer '+sessionStorage.getItem("access_token")
        }
    })
}

export function exportPeoplePassRecord(data) {
    return axios({
        method: 'get',
        url:'/user/passRecord/exportPassRecord',
        params: data,
        responseType: 'blob',
        headers:{
            'Authorization': 'Bearer '+sessionStorage.getItem("access_token")
        }
    })
}
